import axios from 'axios';

const isLocalHost = () => {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1';
};

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (isLocalHost() ? 'http://localhost:8000/api' : `${window.location.origin}/api`);

const TOKEN_KEY = 'flare_customer_token';
const USER_KEY = 'flare_customer_user';

const client = axios.create({
  baseURL: API_BASE_URL,
  headers: { Accept: 'application/json' },
});

client.interceptors.request.use((config) => {
  try {
    const token = window.localStorage.getItem(TOKEN_KEY);
    if (token) config.headers.Authorization = `Bearer ${token}`;
  } catch {}
  return config;
});

client.interceptors.response.use(
  (r) => r,
  (error) => {
    const url = String(error.config?.url || '');
    const isAuthCall = /\/customers\/(login|register|reset-password|otp)/.test(url);
    if (error.response && error.response.status === 401 && !isAuthCall) {
      try {
        window.localStorage.removeItem(TOKEN_KEY);
        window.localStorage.removeItem(USER_KEY);
      } catch {}
      if (!window.location.pathname.startsWith('/login')) {
        const next = encodeURIComponent(window.location.pathname + window.location.search);
        window.location.href = `/login?redirect=${next}`;
      }
    }
    return Promise.reject(error);
  },
);

export function setCustomerSession(token, customer) {
  try {
    if (token) window.localStorage.setItem(TOKEN_KEY, token);
    if (customer) window.localStorage.setItem(USER_KEY, JSON.stringify(customer));
  } catch {}
}

export function getStoredCustomer() {
  try {
    const raw = window.localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function getCustomerToken() {
  try {
    return window.localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function clearCustomerSession() {
  try {
    window.localStorage.removeItem(TOKEN_KEY);
    window.localStorage.removeItem(USER_KEY);
  } catch {}
}

export const customerApi = {
  sendOtp: (data) => client.post('/customers/otp/send', data),
  register: (data) => client.post('/customers/register', data),
  login: (data) => client.post('/customers/login', data),
  resetPassword: (data) => client.post('/customers/reset-password', data),
  me: () => client.get('/customers/me'),
  account: () => client.get('/customers/account'),
  updateMe: (data) => client.put('/customers/me', data),
  changePassword: (data) => client.post('/customers/me/password', data),
};

export default customerApi;
